module.exports = __webpack_public_path__ + "img/cases01.fa87d7e3.png";